export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 200,
      // render: 'sortRender',
    },
    {title: '通道名称', dataIndex: 'configName', width: 160, ellipsis: true},
    {title: '员工名称', dataIndex: 'workerName', width: 120, ellipsis: true},
    {title: '员工登录ID', dataIndex: 'userId', width: 200, ellipsis: true},
    {title: '第三方呼叫账号', dataIndex: 'thirdAccount', width: 160, ellipsis: true},
    {title: '第三方呼叫账号密码', dataIndex: 'password', width: 180, ellipsis: true},
    {title: '最后修改人', dataIndex: 'modifiedByName', width: 160, ellipsis: true},
    {title: '最后修改时间', dataIndex: 'lastUpdatedTime', width: 180, itemType: 'dateTime'},
    {title: '操作', dataIndex: '#', width: 200, fixed: 'right', render: 'actionRender'},
  ],
  search: [
    {
      name: 'workerNameLike',
      label: '员工名称',
    }
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
